import { useState } from 'react';
import { CancellationsSection } from '../cancellation/CancellationsSection';
import type { CancellationProgressWatch } from '../../hooks/useCancellationProgressWatch';
import type { Agreement } from '../../types/agreements.types';
import { manageSections } from '../../utils/cancellationSection';
import { ManageAgreementTab, type ManageAgreementSectionId } from './ManageAgreementTab/ManageAgreementTab';

interface Props {
    agreement: Agreement;
    cancellationWatch: CancellationProgressWatch;
}

export function AgreementManageTab({ agreement, cancellationWatch }: Props) {
    const [selected, setSelected] = useState<ManageAgreementSectionId>('cancellations');
    const sections = manageSections(agreement.cancelAction);

    return (
        <ManageAgreementTab sections={sections} selected={selected} onSelect={setSelected}>
            {selected === 'cancellations' && <CancellationsSection agreement={agreement} watch={cancellationWatch} />}
        </ManageAgreementTab>
    );
}
